// Helpers for the invite landing page: detect in-app browsers (where iOS
// Universal Links / Android App Links never fire) and the host platform, so
// the page can nudge the user out to the real browser or fall back to the
// store. See the WealthHub card sqgok7Qy for the rationale.

// Ordered list of in-app browser signatures. `name` is shown to the user.
const IN_APP_BROWSER_RULES = [
  { name: 'Instagram', test: /Instagram/i },
  { name: 'Messenger', test: /FB_IAB\/Orca|Messenger/i },
  { name: 'Facebook', test: /FBAN|FBAV|FB_IAB/i },
  { name: 'WhatsApp', test: /WhatsApp/i },
  { name: 'Line', test: /\bLine\//i },
  { name: 'TikTok', test: /musical_ly|BytedanceWebview|TikTok/i },
  { name: 'Snapchat', test: /Snapchat/i },
  { name: 'Twitter', test: /Twitter/i },
  { name: 'Google', test: /\bGSA\//i },
];

// In-app browsers that honour the `?openExternalBrowser=1` query param by
// re-opening the URL in the system browser (Facebook family + the Google app).
const HONOURS_EXTERNAL_BROWSER_ESCAPE = new Set([
  'Facebook',
  'Instagram',
  'Messenger',
  'Google',
]);

export function getPlatform(ua = navigator.userAgent) {
  if (/android/i.test(ua)) return 'android';
  if (/iphone|ipad|ipod/i.test(ua)) return 'ios';
  // iPadOS 13+ reports a desktop Safari UA but exposes touch points.
  if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
    return 'ios';
  }
  return 'desktop';
}

// Returns the friendly name of the detected in-app browser, or null for a
// normal browser. Falls back to a generic label for bare Android webviews.
export function detectInAppBrowser(ua = navigator.userAgent) {
  const match = IN_APP_BROWSER_RULES.find((rule) => rule.test.test(ua));
  if (match) return match.name;
  if (/android/i.test(ua) && /;\s*wv\)/i.test(ua)) return 'this app';
  return null;
}

export function honoursExternalBrowserEscape(name) {
  return HONOURS_EXTERNAL_BROWSER_ESCAPE.has(name);
}

// Current URL with `?openExternalBrowser=1` appended — the same https invite
// link, which still triggers the App Link once the system browser opens it.
export function buildExternalBrowserUrl() {
  const url = new URL(window.location.href);
  url.searchParams.set('openExternalBrowser', '1');
  return url.toString();
}
